import {AfterViewInit, Component, ElementRef, Inject, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MappingComponent} from '../../mapping/mapping.component';
import {HelperService} from '../../helper.service';
import {TranslateService} from '@ngx-translate/core';
import {AnalysisManagementService} from '../../services/analysis-management.service';
import {AvailableMapsFieldModel} from '../../models/availableMapsFieldModel';
import {FieldAvailableMapsDto} from '../../dto/FieldAvailableMapsDto';
import {NavBarComponent} from '../../nav-bar/nav-bar.component';
import {FieldOverlayItemModel} from '../../models/fieldOverlayItemModel';
import {AnalysisItemMapsFieldModel} from '../../models/analysisItemMapsFieldModel';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MapsTypesAvailabilityModel} from '../../models/mapsTypesAvailabilityModel';
import dayjs from 'dayjs';
import {ReportService, OrderingDefinition} from '../../services/report.service';
import {AnalysisOrderingDefinitionsComponent} from '../analysis-ordering-definitions/analysis-ordering-definitions.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DownloadSatelliteReportComponent } from 'src/app/dialogs/download-satellite-report/download-satellite-report/download-satellite-report.component';
import { VrtFinaliseDialogComponent } from 'src/app/dialogs/vrt-finalise-dialog/vrt-finalise-dialog.component';
import { VrtNewVersionDialogComponent } from 'src/app/dialogs/vrt-new-version-dialog/vrt-new-version-dialog.component';
import { VrtDownloadDialogComponent } from 'src/app/dialogs/vrt-download-dialog/vrt-download-dialog.component';
import { GeosysManagementService } from 'src/app/services/geosys-management.service';
import { ImageryRequestService, ImageryRequestDto } from 'src/app/services/imagery-request.service';
import { isRequestableImageryType } from 'src/app/maps/utils/requestable-imagery';
import { withYaraLayersTogether } from 'src/app/maps/utils/imagery-type-order';
import { legacyHoverHelpForType } from 'src/app/maps/utils/analysis-sources';
import { Role } from 'src/app/models/role';
// import {SelectedFarmMapsItemModel} from '../../models/selectedFarmMapsItemModel';

@Component({
    selector: 'app-map-data-field',
    templateUrl: './map-data-field.component.html',
    styleUrls: ['./map-data-field.component.css'],
    standalone: false
})

export class MapDataFieldComponent implements AfterViewInit{

  @ViewChildren('navAnalysisItem') navAnalysisItems: QueryList<ElementRef>;

  selectionState: FormGroup;

  // Biomass and N-Uptake listed straight after Yara's NDVI, as on the Maps panel.
  analysisTypes = withYaraLayersTogether<any>(this.data.analysis);
  farmNameHeader = this.data.farmNameHeader;
  fieldId = this.data.fieldID;
  fieldPolygon = this.data.fieldPolygon || [];
  type: string;
  lastFetchedType: string = '';
  selectedPeriod = '30 days';
  startDate =  '';
  endDate =  '';
  lastSelectedType: MapsTypesAvailabilityModel;
  roles: Role[] = JSON.parse(sessionStorage.getItem('roles'));
  listItemDate: any;
  listItemDates = [];
  mappedResponse = [];
  limitedResponse = [];
  filteredList: AvailableMapsFieldModel[] = [];
  availableItems: FieldAvailableMapsDto;
  selectedItem: FieldOverlayItemModel;

  analysisType: any;
  selectedTypeHl:any;
  optionExists:any;
  availableAnalysis:any;

  selectedPeriodBtn = false;
  showAnalysisList = false;
  showChemList = false;
  showProfitabilityInputs = false;
  disablePeriodRange = false;
  showNoDataCard = false;
  autoFocusOn = false;
  hideLoadMoreBtn = false;

  availableYieldMaps: AvailableMapsFieldModel[] = [];
  availableProfitabilityMaps: AvailableMapsFieldModel[] = [];
  selectedYieldMap: AvailableMapsFieldModel = null;
  selectedYieldYear: string = null;
  filteredYieldMaps: AvailableMapsFieldModel[] = [];
  availableYieldYears: string[] = [];
  inputCost: number = null;
  productPrice: number = null;
  viewProfitability: boolean = false;

  // VRT
  showVrtInputs = false;
  viewVrt: boolean = false;
  viewVrtDownloader: boolean = false;
  vrtBaseMapOptions: any[] = [];
  selectedVrtBaseMap: any = null;
  selectedVrtBaseType: any = null;
  selectedVrtYear: string = null;
  availableVrtYears: string[] = [];
  filteredVrtMaps: any[] = [];
  vrtLegendBands: { id: number; label: string; colour: string; assignedRate: number | null }[] = [];
  vrtPropertyTypes: any[] = [];
  selectedVrtPropertyType: any = null;
  vrtMapName: string = '';
  vrtProduct: string = '';
  vrtUnit: string = '';
  vrtUnits: { value: string; label: string }[] = [];
  vrtCurrentAnalysisId: number | null = null;
  private vrtEditVersion: number = 0;
  vrtIsFinalised: boolean = false;
  isGeneratingVrt: boolean = false;
  existingVrtMaps: any[] = [];
  availableVrtBaseMaps: any[] = [];
  vrtPropertyTypeId: number = null;
  isLoadingVrtBaseMaps: boolean = false;

  orderingDefinitions: OrderingDefinition[] = [];
  selectedOrderingDefinitionId: number | null = null;

  isCoveragePercentageAnalysisType: boolean = false;
  filteredItemObj = {
    period: '30 days',
    fieldId: this.data.fieldID,
    type: 'NDVI SATELLITE',
    pageSize: 25,
    pageNumber: 1,
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<MappingComponent>,
              public helper: HelperService,
              public translate: TranslateService,
              public analysisManagementService: AnalysisManagementService,
              public geosysManagementService: GeosysManagementService,
              public nav: NavBarComponent,
              private formBuilder: FormBuilder,
              private imageryRequestService: ImageryRequestService,
              private reportService: ReportService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
  ){
    this.selectionState = this.formBuilder.group({
      prevSelect: ''
    });
  }

  ngOnInit(): void {
    this.viewProfitability = this.roles.some(r => r.name === 'ProfitabilityMapView');
    this.viewVrt = this.roles.some(r => r.name === 'VrtCreator');
    this.viewVrtDownloader = this.roles.some(r => r.name === 'VrtDownloader');

    if (this.data.vrtFromAnalysis) {
      this.nav.toggleLoading(false);
      this.initVrtFromOverlay(this.data.vrtFromAnalysis);
      return;
    }

    this.nav.toggleLoading(true);

    if(this.data.previousValue == undefined && this.data.selectedFarmMapsItem){
      this.lastSelectedType = this.data.selectedFarmMapsItem;
      this.updateImageryRequestVisibility();
      //
    }else{
      this.lastSelectedType = this.data.previousValue;
      this.updateImageryRequestVisibility();
      //
    }

    let mapsTypesAvailabilityModel2: MapsTypesAvailabilityModel = {
      type: this.lastSelectedType?.type,
      available:true,
      alias: this.lastSelectedType?.alias,
      displayOrder: 1,
      selected: true
    };



    if(!this.data.previousValue && this.data.selectedFarmMapsItem){
      this.lastSelectedType = mapsTypesAvailabilityModel2;
    }else if(this.data.previousValue){
      this.lastSelectedType = mapsTypesAvailabilityModel2;

    }
    //

    // if(this.data.previousValue){
    //   this.lastSelectedType = mapsTypesAvailabilityModel2;
    // }

    if (this.farmNameHeader == '') {
      this.farmNameHeader = 'No Farm Selected';
    } else{
      this.farmNameHeader = this.data.farmNameHeader;
    }

    this.optionExists = [];
    this.analysisTypes.forEach(obj => {
      this.optionExists.push(obj.type);
    });

    if(this.lastSelectedType) {
      let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
        type: this.lastSelectedType.type,
        available:true,
        alias: this.lastSelectedType.alias,
        displayOrder: 1,
        selected: true
      };


      if(sessionStorage.getItem('lastSelectedPeriod') !== undefined){
        this.selectedPeriod = sessionStorage.getItem('lastSelectedPeriod');
      }

      this.selectAnalysisType(mapsTypesAvailabilityModel);
    }
    // Set the default value based on the type
    else{

      let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
        type: this.analysisTypes[0].type,
        available: true,
        alias: this.analysisTypes[0].alias,
        displayOrder: 1,
        selected: true
      };

      this.analysisTypes.every(availableType => {
        if(availableType.available && availableType.type === 'NDVI SATELLITE'){
          mapsTypesAvailabilityModel = {
            type: availableType.type,
            available: true,
            alias: availableType.alias,
            displayOrder: 1,
            selected: true
          };
          return false;
        } else if(availableType.available){
          mapsTypesAvailabilityModel = {
            type: availableType.type,
            available: true,
            alias: availableType.alias,
            displayOrder: 1,
            selected: true
          };
          return false;
        }
        return true;
      });



      this.selectionState.controls['prevSelect'].setValue(this.analysisTypes[0].type);
      this.selectAnalysisType(mapsTypesAvailabilityModel);
      this.clickPeriod(this.selectedPeriod);
    }

    this.selectedTypeHl = this.filteredItemObj.type;
    this.setfieldCoveragePercentageDetails();
    this.clickPeriod(this.selectedPeriod);
  }

  selectAnalysisType(selectType: MapsTypesAvailabilityModel) {
    if(selectType?.alias === 'PROFITABILITY' && !this.viewProfitability) {
      this._snackBar.open(('You do not have permission to use this feature.'), this.translate.instant('SNACKBAR.DISMISS'), {
        duration: 10000,
      });
      this.nav.toggleLoading(false);
    } else {
      this.nav.toggleLoading(true);
      //

      // Generated VRT: Creator always enters, Downloader only if data available
      if (selectType?.type === 'GENERATED_VRT') {
        if (!this.viewVrt && !this.viewVrtDownloader) {
          this._snackBar.open('You do not have permission to access this feature.', this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
          this.nav.toggleLoading(false);
          return;
        }
        if (this.viewVrt || this.viewVrtDownloader) {
        this.analysisTypes.forEach(t => t.selected = t.type === selectType.type);
        this.showVrtInputs = true;
        this.showProfitabilityInputs = false;
        this.showAnalysisList = false;
        this.showChemList = false;
        this.showNoDataCard = false;
        this.disablePeriodRange = true;
        this.nav.toggleLoading(false);
        this.loadVrtData();
        return;
        }
        return;
      }

      if (selectType.available || this.isRequestable(selectType.type)) {

        this.analysisTypes.forEach(availableType => {

          if ((availableType.type !== selectType.type) || (availableType.alias !== selectType.alias)) {
            availableType.selected = false;
          }else {
            availableType.selected = true;
          }
          this.type = selectType.type;
        });

        this.filteredList = [];
        let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
          type: selectType.type,
          available:true,
          alias: selectType.alias,
          displayOrder: 1,
          selected: true
        };

        this.selectionState.controls['prevSelect'].setValue(selectType.type);
        this.lastSelectedType = mapsTypesAvailabilityModel;
        this.updateImageryRequestVisibility();
        this.filteredItemObj.type = selectType.type;

        if(this.filteredItemObj.type.toLowerCase().includes('PROFITABILITY'.toLowerCase())){
          this.showProfitabilityInputs = true;
          this.showVrtInputs = false;
          this.showAnalysisList = false;
          this.showChemList = false;
          this.disablePeriodRange = true;
          this.nav.toggleLoading(false);
          this.loadVrtData();
        }
        else if(this.filteredItemObj.type.toLowerCase().includes('SATELLITE'.toLowerCase())){
          if (this.filteredItemObj.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
            this.disablePeriodRange = true;
            this.filteredItemObj.period = 'all';
          } else {
            this.disablePeriodRange = false;
            this.filteredItemObj.period = this.selectedPeriod;
          }
          this.showAnalysisList = true;
          this.showChemList = false;
          this.showProfitabilityInputs = false;
          this.showVrtInputs = false;
        }else{
          this.filteredItemObj.period = 'all';
          this.showAnalysisList = false;
          this.showChemList = true;
          this.showProfitabilityInputs = false;
          this.showVrtInputs = false;
          this.disablePeriodRange = true;
        }
        this.hideLoadMoreBtn = this.selectedPeriod == 'all';
        this.selectedTypeHl =  this.filteredItemObj.type;
        this.setfieldCoveragePercentageDetails();
        this.getFilteredList();
        this.loadOrderingDefinitions();
      }
      else{
        this._snackBar.open(('Selected analysis is not available, please select another.'), this.translate.instant('SNACKBAR.DISMISS'), {
          duration: 10000,
        });
        this.nav.toggleLoading(false);
      }
    }
  }

  getFilteredList() {
    setTimeout(() => {
      if(!this.nav.toggleLoading){
        this.nav.toggleLoading(true);
      }

    }, 200);

    // this.nav.toggleLoading(true);

    setTimeout(() => {
      let fieldAvailableMapsDto: FieldAvailableMapsDto = {
        period: this.filteredItemObj.period,
        fieldId: this.filteredItemObj.fieldId,
        type: this.filteredItemObj.type,
        pageSize: this.filteredItemObj.pageSize,
        pageNumber: this.filteredItemObj.pageNumber
      }
      //

      this.analysisManagementService.getAvailableMapsField(fieldAvailableMapsDto).subscribe(itemList => {

//
        if(this.filteredItemObj.pageNumber <= 1){
          this.filteredList = itemList;

          ///////////////////////// LOAD MORE ////////////////////////////////////
        }else {
          itemList.forEach(item => {
            this.filteredList.push(item);
          })
        }


        if(itemList.length > 0){
          this.showNoDataCard = true;
        }else{
          this.showNoDataCard = false;
        }
        //
      }, error => {},()=>{this.nav.toggleLoading(false);});
    }, 1500);

  }

  clickPeriod(periodRange: string){
    this.filteredItemObj.pageNumber = 1;

    this.selectedPeriod = periodRange;

    let lastSelectedPeriod = periodRange;
    sessionStorage.setItem('lastSelectedPeriod',lastSelectedPeriod);

    this.filteredItemObj.period = periodRange;
    this.hideLoadMoreBtn = periodRange == 'all';
    this.filteredList = [];
    this.getFilteredList();
  }

  loadMore(){
    this.filteredItemObj.pageNumber =  this.filteredItemObj.pageNumber +1;
    this.getFilteredList();
  }

  onCloseClick() {
    this.dialogRef.close();
  }


  // Same role-gated pattern as the existing download icon in this same panel header
  // (helper.doesUserHaveRole('Analysis Reporting')) -- RecacheAnalysisMapView, checked in the
  // template, not duplicated here.
  recachingAnalysisId: number | null = null;

  // Goes through the same RabbitMQ queue the bulk/by-type recache already uses, not a direct
  // synchronous call -- a successful response means "request accepted", not "done". Nothing to
  // poll yet, so this does not reload the list immediately.
  recache(analysisId: number, event: Event): void {
    event.stopPropagation(); // don't also expand/collapse the panel underneath
    if (this.recachingAnalysisId) { return; }

    this.recachingAnalysisId = analysisId;
    this.analysisManagementService.recacheAnalysis(analysisId).subscribe({
      next: () => {
        this.recachingAnalysisId = null;
        this._snackBar.open('Recache requested — this can take a few minutes.', 'Dismiss', { duration: 6000 });
      },
      error: (err) => {
        this.recachingAnalysisId = null;
        // The service's own catchError already opened a snackbar for this -- a specific "already
        // recaching" message for 409, same generic one as any other error otherwise. Showing a
        // second one here for 409 would just replace that message with a less useful one.
        if (err?.status !== 409) {
          this._snackBar.open("Couldn't request a recache. Try again shortly.", 'Dismiss', { duration: 5000 });
        }
      }
    });
  }

  public overlayAnalysis(analysisId: number, datePerformed: string, type: string, item: AnalysisItemMapsFieldModel) {
    var result = {
      analysisId: analysisId,
      datePerformed: datePerformed,
      type: type,
      propertyTypeId: item.propertyTypeId,
      propertyTypeName: item.propertyTypeName,
      mapUrl: item.mapUrl,
      latMax: item.latMax,
      lngMax: item.lngMax,
      latMin: item.latMin,
      lngMin: item.lngMin,
      vrtProduct: (item as any).vrtProduct,
      vrtUnit: (item as any).vrtUnit,
    };
    this.selectedItem = result;

    this.dialogRef.close({
      "selectedItem": this.selectedItem,
      "lastSelectedType": this.lastSelectedType,
    });
  }
  ngAfterViewInit() {
    if (!this.data.vrtFromAnalysis) {
      this.selectAnalysisType(this.lastSelectedType);
    }
  }

  formatDate(date: string, format: string): string {
    return dayjs(date).format(format);
  }
  openSatelliteReportSelectionMenu() {
    const dialogRef = this.dialog.open(DownloadSatelliteReportComponent);

    dialogRef.afterClosed().subscribe(result => {
 
        if (result?.option == 'create') {
          
          this.startDate = result?.startDateFilter;
           this.endDate = result?.endDateFilter;
          this.generateFieldSatelliteAnalysisReport();
        }
    });
  }

  generateFieldAnalysisReport(date, event: Event){
    event.stopPropagation();
    const dialogRef = this.dialog.open(AnalysisOrderingDefinitionsComponent, {
      width: '400px',
      data: {
        orderingDefinitions: this.orderingDefinitions,
        selectedOrderingDefinitionId: this.selectedOrderingDefinitionId,
        showCombinedOption: this.type?.toLowerCase().includes('chemical')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == null) return;
      this.selectedOrderingDefinitionId = result.orderingDefinitionId;
      sessionStorage.setItem('selectedOrderingDefinitionId', result.orderingDefinitionId?.toString() || '');
      this.nav.toggleLoading(true);
      const reportType = result.combined ? 'chemical-combined' : this.type;
      this.reportService.generateFieldAnalysisReport(reportType, date, this.fieldId, true, true, this.selectedOrderingDefinitionId, result.language, result.orientation, result.labelSize, result.labelColor, result.labelStrokeColor)
          .subscribe(response => {
            this.nav.toggleLoading(false);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 15000,
            });
          });
    });
  }


  loadOrderingDefinitions() {
    if (!this.type || !this.type.toLowerCase().includes('chemical')) {
      this.orderingDefinitions = [];
      return;
    }
    const analysisType = this.type.toLowerCase().includes('top') ? 'Top Soil' : 'Sub Soil';
    this.reportService.getOrderingDefinitions(analysisType).subscribe(defs => {
      this.orderingDefinitions = defs || [];
      const stored = sessionStorage.getItem('selectedOrderingDefinitionId');
      if (stored && this.orderingDefinitions.some(d => d.id === +stored)) {
        this.selectedOrderingDefinitionId = +stored;
      } else {
        const defaultDef = this.orderingDefinitions.find(d => d.isDefault);
        this.selectedOrderingDefinitionId = defaultDef ? defaultDef.id : (this.orderingDefinitions.length > 0 ? this.orderingDefinitions[0].id : null);
      }
    });
  }

  onOrderingDefinitionChange(id: number) {
    this.selectedOrderingDefinitionId = id;
    sessionStorage.setItem('selectedOrderingDefinitionId', id.toString());
  }


  generateFieldSatelliteAnalysisReport(){
    
    this.nav.toggleLoading(true);
    // event.stopPropagation();
    // TODO: need to hook this up with actual model.
    this.reportService.generateFieldSatelliteAnalysisReport(this.type, this.startDate, this.endDate, this.fieldId)
        .subscribe(response => {
          this.nav.toggleLoading(false);
          this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT'), this.translate.instant('SNACKBAR.DISMISS'), {
            duration: 15000,
          });
        });
      }

 //Create method to get premiumCoverage
  premiumCoverage(): void {
    this.geosysManagementService.getFieldCoveragePercentageByFieldId(this.fieldId, 'GEOSYS')
      .subscribe(response => {
        this.mappedResponse = response;

        if(this.mappedResponse.length > 0){
            this.isCoveragePercentageAnalysisType = true;
        }else{
          this.isCoveragePercentageAnalysisType = false;
        }

        this.nav.toggleLoading(false);
  });
}

//Create polarisCoverage method - TO DO
polarisCoverage(): void {
  const provider:string = this.lastFetchedType;

  const processedString: string = provider.replace(/\s+/g, "").toLowerCase();
  this.geosysManagementService.getFieldCoveragePercentageByFieldId(this.fieldId, 'POLARIS')
    .subscribe(response => {
      this.mappedResponse = response;

      if(this.mappedResponse.length > 0){
          this.isCoveragePercentageAnalysisType = true;
      }else{
        this.isCoveragePercentageAnalysisType = false;
      }
      this.nav.toggleLoading(false);
    })
}

// Get coverage card Id to overlay corresponding image on click
overlayCoverageCardMapsItem(coverageCard: any): void {
  this.nav.toggleLoading(true);

  // Find the matching analysis from filteredList using the coverage card's date
    const matchingAnalysis = this.filteredList.find(analysis =>
    dayjs(analysis.datePerformed).format('YYYY-MM-DD') === coverageCard?.imageDate
  );

  if (matchingAnalysis && matchingAnalysis?.items && matchingAnalysis?.items?.length > 0) {
    // Use the first item from the matching analysis
    this.overlayAnalysis(
      matchingAnalysis?.analysisId,
      matchingAnalysis?.datePerformed,
      matchingAnalysis?.type,
      matchingAnalysis?.items[0]
    );
  } else {
    // If no matching analysis found, create a minimal overlay using coverage data
    const result = null;

    this.selectedItem = result;

    this._snackBar.open(('No data available for the selected date.'), this.translate.instant('SNACKBAR.DISMISS'), {
          duration: 15000,
    });
  }

  this.nav.toggleLoading(false);
}

setfieldCoveragePercentageDetails(): void {
  if (this.lastFetchedType === this.selectedTypeHl) {
    return;
  }
  this.lastFetchedType = this.selectedTypeHl;

  switch (this.selectedTypeHl) {
    case 'NDVI SATELLITE':
      this.premiumCoverage();
      break;
    case 'YARA NDVI SATELLITE':
      this.polarisCoverage();
      break;
    default:
      this.clearCoverageData();
  }
}


clearCoverageData(): void {
  this.mappedResponse = [];
  this.isCoveragePercentageAnalysisType = false;
  this.nav.toggleLoading(false);
}


  loadYieldMaps() {
    let fieldAvailableMapsDto: FieldAvailableMapsDto = {
      period: 'all',
      fieldId: this.fieldId,
      type: 'YIELD',
      pageSize: 100,
      pageNumber: 1
    };

    this.analysisManagementService.getAvailableMapsField(fieldAvailableMapsDto)
      .subscribe(
        itemList => {
          this.availableYieldMaps = itemList;
          this.availableYieldYears = [...new Set(itemList.map(item => this.formatDate(item.datePerformed, 'YYYY')))] as string[];
        },
        error => {},
        () => {}
      );
  }

  onYieldYearChange() {
    if (this.selectedYieldYear) {
      this.filteredYieldMaps = this.availableYieldMaps.filter(map =>
        this.formatDate(map.datePerformed, 'YYYY') === this.selectedYieldYear
      );
      this.selectedYieldMap = null;
    } else {
      this.filteredYieldMaps = [];
      this.selectedYieldMap = null;
    }
  }

  isLoadingProfitabilityMaps: boolean = false;

  loadProfitabilityMaps() {
    this.isLoadingProfitabilityMaps = true;
    this.analysisManagementService.getProfitabilityAnalyses(this.fieldId)
      .subscribe(
        itemList => {
          this.availableProfitabilityMaps = itemList.sort((a, b) =>
            new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime()
          );
          this.isLoadingProfitabilityMaps = false;
        },
        error => {
          this.isLoadingProfitabilityMaps = false;
        },
        () => {}
      );
  }

  generateProfitabilityMap() {
    if (!this.selectedYieldMap || !this.inputCost || !this.productPrice) {
      this._snackBar.open('Please fill all fields', 'Dismiss', { duration: 3000 });
      return;
    }

    this.nav.toggleLoading(true);

    this.analysisManagementService.generateProfitabilityMap(
      this.selectedYieldMap.analysisId,
      this.fieldId,
      this.inputCost,
      this.productPrice
    ).subscribe(
      response => {
        this.nav.toggleLoading(false);
        this._snackBar.open('Profitability map generation started. It will appear in the list when ready.', 'Dismiss', { duration: 5000 });
        this.isLoadingProfitabilityMaps = true;
        setTimeout(() => {
          this.loadProfitabilityMaps();
        }, 5000);
      },
      error => {
        this.nav.toggleLoading(false);
        this._snackBar.open('Failed to generate profitability map', 'Dismiss', { duration: 5000 });
      }
    );
  }

  formatTimestampUTC(timestamp: string): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    date.setHours(date.getHours() + 2);
    return date.toISOString().replace('T', ' ').replace('Z', '').split('.')[0];
  }

  // VRT Methods
  get displayedVrtMaps() {
    if (this.viewVrt) return this.existingVrtMaps;
    return this.existingVrtMaps.filter(m => m.isFinalised);
  }

  initVrtFromOverlay(overlay: any) {
    let vrtType = this.analysisTypes.find(t => t.type === 'GENERATED_VRT');
    if (!vrtType) {
      vrtType = { type: 'GENERATED_VRT', available: true, alias: 'Generated VRT', displayOrder: 1, selected: false };
      this.analysisTypes.push(vrtType);
    }
    this.selectAnalysisType({ type: 'GENERATED_VRT', available: true, alias: vrtType.alias, displayOrder: 1, selected: true });

    setTimeout(() => {
      const baseType = this.vrtBaseMapOptions.find(o => o.type.toLowerCase() === overlay.type?.toLowerCase());
      if (baseType) {
        this.selectedVrtBaseType = baseType;
        this.onVrtBaseTypeSelected();
        const sub = setInterval(() => {
          if (!this.isLoadingVrtBaseMaps && this.availableVrtBaseMaps.length > 0) {
            clearInterval(sub);
            const match = this.availableVrtBaseMaps.find(m => m.analysisId === overlay.analysisId);
            if (match) {
              this.selectedVrtYear = this.formatDate(match.datePerformed, 'YYYY');
              this.onVrtYearChange();
              this.selectedVrtBaseMap = match;
              this.onVrtBaseMapSelected();
            }
          }
        }, 100);
      }
    }, 200);
  }

  loadVrtData() {
    this.vrtUnits = [
      { value: 'L/ha', label: 'Litres per hectare' },
      { value: 'kg/ha', label: 'Kilograms per hectare' },
      { value: 'seeds/ha', label: 'Seeds per hectare' }
    ];
    // Get VRT property type ID from the analysis types list
    const vrtType = this.analysisTypes.find(t => t.type === 'GENERATED_VRT');
    if (vrtType) this.vrtPropertyTypeId = vrtType.propertyTypeId || vrtType.id;
    this.loadVrtBaseMaps();
    this.loadExistingVrtMaps();
  }

  loadVrtBaseMaps() {
    this.vrtBaseMapOptions = this.analysisTypes
      .filter(t => t.available && t.alias !== 'VRT' && t.alias !== 'PROFITABILITY')
      .map(t => ({ type: t.type, alias: t.alias }));
  }

  loadExistingVrtMaps() {
    this.analysisManagementService.listVrtForField(this.fieldId).subscribe({
      next: (maps) => { this.existingVrtMaps = maps; },
      error: () => { this.existingVrtMaps = []; }
    });
  }

  onVrtBaseTypeSelected() {
    this.selectedVrtYear = null;
    this.selectedVrtBaseMap = null;
    this.filteredVrtMaps = [];
    this.vrtLegendBands = [];
    this.vrtPropertyTypes = [];
    this.selectedVrtPropertyType = null;
    if (!this.selectedVrtBaseType) return;

    this.isLoadingVrtBaseMaps = true;
    let fieldAvailableMapsDto: FieldAvailableMapsDto = {
      period: 'all',
      fieldId: this.fieldId,
      type: this.selectedVrtBaseType.type,
      pageSize: 100,
      pageNumber: 1
    };

    this.analysisManagementService.getAvailableMapsField(fieldAvailableMapsDto).subscribe(itemList => {
      this.availableVrtBaseMaps = itemList;
      this.availableVrtYears = [...new Set(itemList.map(item => this.formatDate(item.datePerformed, 'YYYY')))] as string[];
      this.isLoadingVrtBaseMaps = false;
    }, () => { this.isLoadingVrtBaseMaps = false; });
  }

  onVrtYearChange() {
    this.selectedVrtBaseMap = null;
    this.vrtLegendBands = [];
    if (this.selectedVrtYear) {
      this.filteredVrtMaps = this.availableVrtBaseMaps.filter(map =>
        this.formatDate(map.datePerformed, 'YYYY') === this.selectedVrtYear
      );
    }
  }

  onVrtBaseMapSelected() {
    if (!this.selectedVrtBaseMap) return;
    this.selectedVrtPropertyType = null;
    this.vrtLegendBands = [];
    this.analysisManagementService.getAnalysisTypes(this.selectedVrtBaseMap.analysisId).subscribe({
      next: (types: any[]) => {
        this.vrtPropertyTypes = types.map(t => ({
          id: t.id,
          name: t.name,
          legendProperties: t.analysisTypeLegend?.analysisTypeLegendProperties || []
        }));
        if (this.vrtPropertyTypes.length === 1) {
          this.selectedVrtPropertyType = this.vrtPropertyTypes[0];
          this.onVrtPropertyTypeSelected();
        }
      },
      error: () => { this.vrtPropertyTypes = []; }
    });
  }

  onVrtPropertyTypeSelected() {
    if (!this.selectedVrtPropertyType) return;
    const props = this.selectedVrtPropertyType.legendProperties;
    const seen = new Set();
    const uniqueProps = props.filter(p => {
      const key = `${p.minValue}_${p.maxValue}_${p.Colour || p.colour}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    const version = this.vrtEditVersion;
    // Get actual polygon colours to filter bands that have data
    this.analysisManagementService.getAnalysisColoursArea(this.selectedVrtBaseMap.analysisId, this.selectedVrtPropertyType.id).subscribe({
      next: (colours: any[]) => {
        if (this.vrtEditVersion !== version) return;
        const existingColours = new Set(colours.map(c => c.colour));
        const bandsWithData = uniqueProps.filter(b => existingColours.has(b.Colour || b.colour));
        this.vrtLegendBands = (bandsWithData.length > 0 ? bandsWithData : uniqueProps).map(b => ({
          id: b.id,
          label: b.minValue != null && b.maxValue != null && b.minValue !== -1
            ? `${b.minValue} – ${b.maxValue}`
            : (b.textValue || ''),
          colour: b.Colour || b.colour || '#ccc',
          assignedRate: null
        }));
      },
      error: () => {
        if (this.vrtEditVersion !== version) return;
        this.vrtLegendBands = uniqueProps.map(b => ({
          id: b.id,
          label: b.minValue != null && b.maxValue != null && b.minValue !== -1
            ? `${b.minValue} – ${b.maxValue}`
            : (b.textValue || ''),
          colour: b.Colour || b.colour || '#ccc',
          assignedRate: null
        }));
      }
    });
  }

  generateVrt() {
    this.isGeneratingVrt = true;
    const payload = {
      fieldId: this.fieldId,
      sourceAnalysisId: this.selectedVrtBaseMap.analysisId,
      sourcePropertyTypeId: this.selectedVrtPropertyType?.id,
      mapName: this.vrtMapName,
      product: this.vrtProduct,
      unit: this.vrtUnit,
      legendAssignments: this.vrtLegendBands.map(b => ({
        legendPropertyId: b.id,
        assignedRate: b.assignedRate || 0
      }))
    };

    if (this.vrtCurrentAnalysisId) {
      this.analysisManagementService.regenerateVrt(this.vrtCurrentAnalysisId, payload).subscribe({
        next: (res) => {
          this.vrtCurrentAnalysisId = res.analysisId;
          this.isGeneratingVrt = false;
          this._snackBar.open('VRT map regenerated', 'OK', { duration: 3000 });
          this.loadExistingVrtMaps();
        },
        error: (err) => {
          this.isGeneratingVrt = false;
          this._snackBar.open('Failed to regenerate VRT map', 'OK', { duration: 5000 });
        }
      });
    } else {
      this.analysisManagementService.createVrt(payload).subscribe({
        next: (res) => {
          this.vrtCurrentAnalysisId = res.analysisId;
          this.isGeneratingVrt = false;
          this._snackBar.open('VRT map created', 'OK', { duration: 3000 });
          this.loadExistingVrtMaps();
          // Clear form for next creation
          this.selectedVrtBaseType = null;
          this.selectedVrtYear = null;
          this.selectedVrtBaseMap = null;
          this.selectedVrtPropertyType = null;
          this.vrtLegendBands = [];
          this.vrtPropertyTypes = [];
          this.vrtMapName = '';
          this.vrtProduct = '';
          this.vrtUnit = '';
          this.vrtCurrentAnalysisId = null;
        },
        error: (err) => {
          this.isGeneratingVrt = false;
          this._snackBar.open('Failed to create VRT map', 'OK', { duration: 5000 });
        }
      });
    }
  }

  getVrtSourceMapUrl(): string | null {
    if (!this.selectedVrtBaseMap?.items?.length) return null;
    const item = this.selectedVrtPropertyType
      ? this.selectedVrtBaseMap.items.find(i => i.propertyTypeId === this.selectedVrtPropertyType.id)
      : this.selectedVrtBaseMap.items[0];
    return item?.mapUrl || null;
  }

  canGenerateVrt(): boolean {
    return !!this.selectedVrtBaseMap && !!this.vrtMapName && !!this.vrtUnit
      && this.vrtLegendBands.length > 0
      && this.vrtLegendBands.every(b => b.assignedRate !== null);
  }

  openFinaliseDialog() {
    const dialogRef = this.dialog.open(VrtFinaliseDialogComponent, {
      width: '500px',
      data: { mapName: this.vrtMapName }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.finaliseVrt();
      }
    });
  }

  finaliseVrt() {
    this.isGeneratingVrt = true;
    this.analysisManagementService.finaliseVrt(this.vrtCurrentAnalysisId).subscribe({
      next: (res) => {
        this.vrtIsFinalised = true;
        this.isGeneratingVrt = false;
        this._snackBar.open('VRT map finalised successfully', 'OK', { duration: 3000 });
        this.loadExistingVrtMaps();
        this.vrtLegendBands = [];
        this.cancelEditVrt();
      },
      error: () => {
        this.isGeneratingVrt = false;
        this._snackBar.open('Failed to finalise VRT map', 'OK', { duration: 5000 });
      }
    });
  }

  newVersionVrt(vrt: any) {
    const dialogRef = this.dialog.open(VrtNewVersionDialogComponent, {
      width: '400px',
      data: { mapName: vrt.mapName }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.nav.toggleLoading(true);
        this.analysisManagementService.createVrtNewVersion(vrt.analysisId).subscribe({
          next: (res) => {
            this.nav.toggleLoading(false);
            this._snackBar.open('New version created', 'OK', { duration: 3000 });
            this.loadExistingVrtMaps();
            this.editVrt({ ...vrt, analysisId: res.analysisId, isFinalised: false });
          },
          error: () => {
            this.nav.toggleLoading(false);
            this._snackBar.open('Failed to create new version', 'OK', { duration: 5000 });
          }
        });
      }
    });
  }

  downloadVrt(vrt: any) {
    const dialogRef = this.dialog.open(VrtDownloadDialogComponent, {
      width: '450px',
      data: { mapName: vrt.mapName }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.nav.toggleLoading(true);
        this.analysisManagementService.downloadVrtShapefile(vrt.analysisId).subscribe({
          next: (res) => {
            this.nav.toggleLoading(false);
            const byteChars = atob(res.data);
            const byteArray = new Uint8Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) byteArray[i] = byteChars.charCodeAt(i);
            const blob = new Blob([byteArray], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = res.filename || (vrt.mapName || 'vrt') + '.zip';
            a.click();
            window.URL.revokeObjectURL(url);
          },
          error: () => {
            this.nav.toggleLoading(false);
            this._snackBar.open('Failed to download shapefile', 'OK', { duration: 5000 });
          }
        });
      }
    });
  }

  cancelEditVrt() {
    this.vrtEditVersion++;
    this.vrtCurrentAnalysisId = null;
    this.vrtIsFinalised = false;
    this.vrtMapName = '';
    this.vrtProduct = '';
    this.vrtUnit = '';
    this.selectedVrtBaseType = null;
    this.selectedVrtYear = null;
    this.selectedVrtBaseMap = null;
    this.selectedVrtPropertyType = null;
    this.vrtLegendBands = [];
    this.vrtPropertyTypes = [];
    this.filteredVrtMaps = [];
    this.availableVrtYears = [];
  }

  selectExistingVrt(vrt: any) {
    this.vrtCurrentAnalysisId = vrt.analysisId;
    this.vrtMapName = vrt.mapName;
    this.vrtIsFinalised = vrt.isFinalised;
    if (vrt.product) this.vrtProduct = vrt.product;
    if (vrt.unit) this.vrtUnit = vrt.unit;

    this.lastSelectedType = { type: 'GENERATED_VRT', available: true, alias: 'Generated VRT', displayOrder: 1, selected: true };

    // Trigger map overlay
    const item = { propertyTypeId: this.vrtPropertyTypeId, propertyTypeName: 'VRT', mapUrl: null, latMax: null, lngMax: null, latMin: null, lngMin: null, vrtProduct: vrt.product, vrtUnit: vrt.unit };
    this.overlayAnalysis(vrt.analysisId, vrt.createdAt, 'GENERATED_VRT', item as any);
  }

  editVrt(vrt: any) {
    // Clear previous state
    this.selectedVrtBaseType = null;
    this.selectedVrtYear = null;
    this.selectedVrtBaseMap = null;
    this.selectedVrtPropertyType = null;
    this.vrtLegendBands = [];
    this.vrtPropertyTypes = [];
    this.filteredVrtMaps = [];
    this.availableVrtYears = [];

    this.vrtCurrentAnalysisId = vrt.analysisId;
    this.vrtMapName = vrt.mapName;
    this.vrtIsFinalised = vrt.isFinalised;
    if (vrt.product) this.vrtProduct = vrt.product;
    if (vrt.unit) this.vrtUnit = vrt.unit;

    // Load full details to reconstruct the form
    const version = this.vrtEditVersion;
    this.analysisManagementService.getVrtDetails(vrt.analysisId).subscribe({
      next: (details) => {
        if (this.vrtEditVersion !== version) return;
        // Find the base map in availableVrtBaseMaps by sourceAnalysisId
        // First find which type it belongs to
        for (const type of this.vrtBaseMapOptions) {
          let fieldAvailableMapsDto: FieldAvailableMapsDto = {
            period: 'all',
            fieldId: this.fieldId,
            type: type.type,
            pageSize: 100,
            pageNumber: 1
          };
          this.analysisManagementService.getAvailableMapsField(fieldAvailableMapsDto).subscribe(itemList => {
            if (this.vrtEditVersion !== version) return;
            const match = itemList.find(m => m.analysisId === details.sourceAnalysisId);
            if (match) {
              this.selectedVrtBaseType = type;
              this.availableVrtBaseMaps = itemList;
              this.availableVrtYears = [...new Set(itemList.map(item => this.formatDate(item.datePerformed, 'YYYY')))] as string[];
              this.selectedVrtYear = this.formatDate(match.datePerformed, 'YYYY');
              this.filteredVrtMaps = itemList.filter(m => this.formatDate(m.datePerformed, 'YYYY') === this.selectedVrtYear);
              this.selectedVrtBaseMap = match;

              // Load property types
              this.analysisManagementService.getAnalysisTypes(details.sourceAnalysisId).subscribe({
                next: (types: any[]) => {
                  if (this.vrtEditVersion !== version) return;
                  this.vrtPropertyTypes = types.map(t => ({
                    id: t.id,
                    name: t.name,
                    legendProperties: t.analysisTypeLegend?.analysisTypeLegendProperties || []
                  }));
                  if (details.sourcePropertyTypeId) {
                    this.selectedVrtPropertyType = this.vrtPropertyTypes.find(pt => pt.id === details.sourcePropertyTypeId);
                    if (this.selectedVrtPropertyType && details.legendAssignments) {
                      // Populate bands directly from stored assignments
                      const props = this.selectedVrtPropertyType.legendProperties;
                      this.vrtLegendBands = details.legendAssignments.map(a => {
                        const band = props.find(p => p.id === a.legendPropertyId);
                        return {
                          id: a.legendPropertyId,
                          label: band ? (band.minValue != null && band.maxValue != null && band.minValue !== -1 ? `${band.minValue} – ${band.maxValue}` : (band.textValue || '')) : '',
                          colour: band ? (band.Colour || band.colour || '#ccc') : '#ccc',
                          assignedRate: a.assignedRate
                        };
                      });
                    } else if (this.selectedVrtPropertyType) {
                      this.onVrtPropertyTypeSelected();
                    }
                  }
                }
              });
            }
          });
        }
      }
    });

    this._snackBar.open(`Editing: ${vrt.mapName}`, 'OK', { duration: 2000 });
  }


  // ============================================
  // Imagery Request
  // ============================================
  showImageryRequestButton: boolean = false;
  imageryRequestScope: 'FIELD' | 'FARM' = 'FIELD';
  imageryRequestDateOption: '30days' | '60days' | '90days' | 'custom' = '30days';
  imageryRequestDateFrom: Date = null;
  imageryRequestDateTo: Date = null;
  isRequestingImagery: boolean = false;
  imageryDateToday: string = '';
  imageryDate30DaysAgo: string = '';
  imageryRequestDateFromStr: string = '';
  imageryRequestDateToStr: string = '';
  showScopeMenu: boolean = false;
  showDateMenu: boolean = false;

  /**
   * Check if the imagery request button should be shown
   * Only show for the requestable types (Yara NDVI, biomass, N-Uptake; not FIXED)
   */
  updateImageryRequestVisibility(): void {
    const type = this.lastSelectedType?.type || '';
    //console.log('[IMAGERY] lastSelectedType:', this.lastSelectedType, 'type:', type);
    this.showImageryRequestButton = isRequestableImageryType(type);
    //console.log('[IMAGERY] showImageryRequestButton:', this.showImageryRequestButton);
    
    // Update date labels
    this.imageryDateToday = dayjs().format('DD MMM YYYY');
    this.imageryDate30DaysAgo = dayjs().subtract(30, 'day').format('DD MMM YYYY');
  }

  /**
   * Get label for selected date option
   */
  getDateOptionLabel(): string {
    switch (this.imageryRequestDateOption) {
      case '30days': return 'Last 30 Days';
      case '60days': return 'Last 60 Days';
      case '90days': return 'Last 90 Days';
      case 'custom': return 'Custom Range...';
      default: return 'Last 30 Days';
    }
  }

  /**
   * Handle date picker changes
   */
  onDateFromChange(dateStr: string): void {
    this.imageryRequestDateFromStr = dateStr;
    this.imageryRequestDateFrom = dateStr ? new Date(dateStr + 'T00:00:00') : null;
  }

  onDateToChange(dateStr: string): void {
    this.imageryRequestDateToStr = dateStr;
    this.imageryRequestDateTo = dateStr ? new Date(dateStr + 'T00:00:00') : null;
  }

  /**
   * Submit an imagery request
   */
  /** Biomass and N-Uptake exist only on request, so they stay selectable with no data. */
  isRequestable(type: string): boolean {
    return isRequestableImageryType(type);
  }

  /** Hover text for Biomass and N-Uptake, the Maps panel's "?" text; '' shows no tooltip. */
  hoverHelp(type: string): string {
    return legacyHoverHelpForType(type);
  }

  /** "Request NDVI Imagery" as before for NDVI; the type's alias for the others. */
  get imageryRequestTitle(): string {
    const type = (this.lastSelectedType?.type || '').toUpperCase();
    return type === 'YARA NDVI SATELLITE' ? 'Request NDVI Imagery' : `Request ${this.lastSelectedType?.alias || type} Imagery`;
  }

  submitImageryRequest(): void {
    if (this.isRequestingImagery) return;

    this.isRequestingImagery = true;

    const request: ImageryRequestDto = {
      level: this.imageryRequestScope,
      targetId: this.imageryRequestScope === 'FIELD' ? this.fieldId : this.data.farmId,
      fileType: this.lastSelectedType?.type || 'YARA NDVI SATELLITE',
    };

    // Use dateFrom/dateTo format - set daysBack to null to signal scheduler to use actual dates
    if (this.imageryRequestDateOption === 'custom' && this.imageryRequestDateFrom) {
      request.dateFrom = dayjs(this.imageryRequestDateFrom).format('YYYY-MM-DD');
      request.dateTo = this.imageryRequestDateTo 
        ? dayjs(this.imageryRequestDateTo).format('YYYY-MM-DD') 
        : dayjs().format('YYYY-MM-DD');
      request.daysBack = null;  // Signal to use dateFrom/dateTo instead of calculating from today
    } else {
      // Preset date ranges
      let daysBack = 30;
      if (this.imageryRequestDateOption === '60days') daysBack = 60;
      else if (this.imageryRequestDateOption === '90days') daysBack = 90;
      
      request.dateFrom = dayjs().subtract(daysBack, 'day').format('YYYY-MM-DD');
      request.dateTo = dayjs().format('YYYY-MM-DD');
    }

    this.imageryRequestService.requestImagery(request).subscribe({
      next: (response) => {
        this.isRequestingImagery = false;
        const scopeLabel = this.imageryRequestScope === 'FIELD' ? 'field' : 'farm';
        this._snackBar.open(
          `Imagery request submitted for ${scopeLabel}. Processing will take a few minutes.`,
          this.translate.instant('SNACKBAR.DISMISS'),
          { duration: 8000 }
        );
        // Reset form
        this.imageryRequestScope = 'FIELD';
        this.imageryRequestDateOption = '30days';
        this.imageryRequestDateFrom = null;
        this.imageryRequestDateTo = null;
      },
      error: (error) => {
        this.isRequestingImagery = false;
        console.error('Imagery request failed:', error);
        this._snackBar.open(
          'Failed to submit imagery request. Please try again.',
          this.translate.instant('SNACKBAR.DISMISS'),
          { duration: 5000 }
        );
      }
    });
  }

}
